(function () {
  var cardSelector = '.product-card-revamp[data-combined-product-card]';
  var openSizePanel = null;
  var toastTimeout = null;

  function showToast(message, type) {
    if (!message) return;

    var existingToast = document.querySelector('.theme-toast-notification');
    if (existingToast && existingToast.parentNode) {
      existingToast.parentNode.removeChild(existingToast);
    }
    if (toastTimeout) {
      clearTimeout(toastTimeout);
      toastTimeout = null;
    }

    var toast = document.createElement('div');
    toast.className = 'theme-toast-notification' + (type ? ' theme-toast--' + type : '');

    var iconHtml = '<svg class="theme-toast-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';

    if (type === 'success') {
      iconHtml = '<svg class="theme-toast-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg>';
    }

    toast.innerHTML = iconHtml + '<span class="theme-toast-message">' + message + '</span>';
    document.body.appendChild(toast);

    // Trigger reflow to start transition
    toast.offsetHeight;
    toast.classList.add('is-visible');

    toastTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.classList.add('is-hiding');
      setTimeout(function () {
        if (toast && toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3500);
  }

  window.themeShowToast = showToast;

  function parseProducts(container) {
    var script = container && container.querySelector('[data-combined-product-json]');

    if (!script) {
      return [];
    }

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function cleanCurrency(text) {
    if (!text) return '';
    return String(text)
      .replace(/Rs\.?\s*/g, '₹')
      .replace(/\/\-/g, '')
      .replace(/₹\s+/g, '₹')
      .trim();
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) {
      return '';
    }

    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      try {
        var fmt = (theme.settings && (theme.settings.moneyFormat || theme.moneyFormat)) || theme.moneyFormat;
        return cleanCurrency(theme.Currency.formatMoney(cents, fmt));
      } catch (e) {}
    }

    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || (window.theme && theme.moneyFormat) || '₹{{amount_no_decimals}}';
    var value = (cents / 100).toFixed(2);

    return cleanCurrency(
      format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
    );
  }

  function renderPrice(card, product) {
    var priceEl = card.querySelector('[data-combined-product-card-price]');

    if (!priceEl || !product) {
      return;
    }

    var compareAtRaw = product.compareAtPriceRaw || product.compare_at_price || 0;
    var priceRaw = product.price || product.price_min || 0;
    var discount = typeof product.discountPercentage !== 'undefined' ? product.discountPercentage : 0;

    var compareAtText = '';
    var priceText = '';

    if (product.compareAtPrice) {
      compareAtText = cleanCurrency(product.compareAtPrice);
    } else if (compareAtRaw > 0) {
      compareAtText = formatMoney(compareAtRaw);
    }

    if (product.price) {
      priceText = formatMoney(product.price);
    }

    if ((!priceText || !compareAtText) && product.priceHtml) {
      var temp = document.createElement('div');
      temp.innerHTML = product.priceHtml;
      var curr = temp.querySelector('.regularPrice, .focused-price, .ccPrice, .product-card-revamp__price-current');
      var orig = temp.querySelector('.grid-product__price--original, .product-card-revamp__price-original');
      if (!priceText && curr) {
        priceText = cleanCurrency(curr.textContent);
      } else if (!priceText) {
        priceText = cleanCurrency(temp.textContent);
      }
      if (!compareAtText && orig) {
        compareAtText = cleanCurrency(orig.textContent);
      }
    }

    var isOnSale = false;
    if (compareAtRaw > 0 && priceRaw > 0 && compareAtRaw > priceRaw) {
      isOnSale = true;
      if (!discount) {
        discount = Math.round(((compareAtRaw - priceRaw) * 100) / compareAtRaw);
      }
    } else if (compareAtText && compareAtText !== priceText) {
      isOnSale = true;
    }

    var html = '';
    if (isOnSale && compareAtText) {
      html += '<span class="grid-product__price--original product-card-revamp__price-original">' + compareAtText + '</span>';
    }
    if (priceText) {
      html += '<span class="ccPrice product-card-revamp__price-current">' + priceText + '</span>';
    }
    if (isOnSale && discount > 0) {
      html += '<span class="product-card-revamp__discount" data-product-card-discount>' + discount + '%</span>';
    }

    if (html) {
      priceEl.innerHTML = html;
      card.setAttribute('data-product-card-discount-value', isOnSale && discount > 0 ? discount : '0');
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderTitle(card, product) {
    var titleEl = card.querySelector('[data-combined-product-card-title]');

    if (!titleEl) {
      return;
    }

    if (product && product.fabricAndTitle && product.categoryAndColor) {
      titleEl.innerHTML = '<span class="product-card-title__fabric">' + escapeHtml(product.fabricAndTitle) + '</span><span class="product-card-title__category">' + escapeHtml(product.categoryAndColor) + '</span>';
      titleEl.classList.add('product-card-revamp__title--custom-meta');
      return;
    }

    var fabricEl = titleEl.querySelector('.product-card-title__fabric');
    var categoryEl = titleEl.querySelector('.product-card-title__category');
    if (fabricEl && categoryEl && (!product || !product.isSwatchSwitch)) {
      return;
    }

    if (!product || !product.isSwatchSwitch) {
      var attrFabric = titleEl.getAttribute('data-fabric-and-title');
      var attrCategory = titleEl.getAttribute('data-category-and-color');
      if (attrFabric && attrCategory) {
        titleEl.innerHTML = '<span class="product-card-title__fabric">' + escapeHtml(attrFabric) + '</span><span class="product-card-title__category">' + escapeHtml(attrCategory) + '</span>';
        titleEl.classList.add('product-card-revamp__title--custom-meta');
        return;
      }
    }

    titleEl.classList.remove('product-card-revamp__title--custom-meta');
    var baseTitle = titleEl.getAttribute('data-base-title') || '';
    var rawTitle = (product && product.title) || titleEl.textContent || '';

    if (!baseTitle) {
      if (rawTitle.indexOf(' — ') > -1) {
        baseTitle = rawTitle.split(' — ')[0].trim();
      } else if (rawTitle.indexOf(' - ') > -1) {
        baseTitle = rawTitle.split(' - ')[0].trim();
      } else {
        baseTitle = rawTitle.trim();
      }
    }

    var colorName = (product && (product.variantLabel || product.color || product.subtitle)) || '';
    if (!colorName && rawTitle) {
      if (rawTitle.indexOf(' — ') > -1) {
        colorName = rawTitle.split(' — ').pop().trim();
      } else if (rawTitle.indexOf(' - ') > -1) {
        colorName = rawTitle.split(' - ').pop().trim();
      }
    }

    if (colorName && colorName !== baseTitle) {
      titleEl.textContent = baseTitle + ' — ' + colorName;
    } else {
      titleEl.textContent = baseTitle;
    }
  }

  function getProductSubtitle(product, card) {
    if (!product) {
      return '';
    }

    var subtitleEl = card && card.querySelector('[data-combined-product-card-subtitle]');
    var extraInfo = (product && product.extraInfo) || (subtitleEl && subtitleEl.getAttribute('data-extra-info')) || '';

    if (extraInfo && typeof extraInfo === 'string') {
      return extraInfo.trim();
    }

    return '';
  }

  function ensureSubtitleVisible(card) {
    var subtitleEl = card.querySelector('[data-combined-product-card-subtitle]');

    if (!subtitleEl) {
      return;
    }

    if (subtitleEl.textContent && subtitleEl.textContent.trim()) {
      subtitleEl.hidden = false;
      subtitleEl.removeAttribute('hidden');
      subtitleEl.style.display = 'block';
      subtitleEl.style.visibility = 'visible';
    } else {
      subtitleEl.hidden = true;
      subtitleEl.setAttribute('hidden', '');
      subtitleEl.style.display = 'none';
    }
  }

  function renderSubtitle(card, product) {
    var subtitleEl = card.querySelector('[data-combined-product-card-subtitle]');

    if (!subtitleEl) {
      return;
    }

    var subtitleText = getProductSubtitle(product, card);
    subtitleEl.textContent = subtitleText;
    if (subtitleText) {
      ensureSubtitleVisible(card);
    } else {
      subtitleEl.hidden = true;
      subtitleEl.setAttribute('hidden', '');
      subtitleEl.style.display = 'none';
    }
  }

  function renderSizeGrid(card, product) {
    var grid = card.querySelector('[data-product-card-size-grid]');

    if (!grid) {
      return;
    }

    var sizes = product.sizeVariants || [];

    grid.innerHTML = sizes.map(function (size) {
      var unavailableClass = size.available ? '' : ' is-unavailable';
      var disabled = size.available ? '' : ' aria-disabled="true"';

      return '<button type="button" class="product-card-revamp__size-btn' + unavailableClass + '" data-product-card-size-option data-variant-id="' + size.id + '"' + disabled + ' role="listitem">' + size.label + '</button>';
    }).join('');
  }

  function updateSizeChart(card, product) {
    if (product.sizeChartCm) {
      card.setAttribute('data-size-chart-cm', product.sizeChartCm);
    }

    if (product.sizeChartIn) {
      card.setAttribute('data-size-chart-in', product.sizeChartIn);
    }

    var modal = card.querySelector('[data-product-card-size-chart-modal]');

    if (!modal) {
      return;
    }

    var cmImage = modal.querySelector('[data-size-chart-image="cm"]');
    var inImage = modal.querySelector('[data-size-chart-image="in"]');
    var tabs = modal.querySelector('.product-card-revamp__size-chart-tabs');

    if (cmImage && product.sizeChartCm) {
      cmImage.src = product.sizeChartCm;
      cmImage.classList.add('is-active');
    } else if (cmImage) {
      cmImage.removeAttribute('src');
      cmImage.classList.remove('is-active');
    }

    if (inImage && product.sizeChartIn) {
      inImage.src = product.sizeChartIn;

      if (!product.sizeChartCm) {
        inImage.classList.add('is-active');
      } else {
        inImage.classList.remove('is-active');
      }
    } else if (inImage) {
      inImage.removeAttribute('src');
      inImage.classList.remove('is-active');
    }

    if (tabs) {
      tabs.hidden = !(product.sizeChartCm && product.sizeChartIn);
    }

    var sizeChartBtn = card.querySelector('[data-product-card-size-chart]');
    if (sizeChartBtn) {
      sizeChartBtn.hidden = !(product.sizeChartCm || product.sizeChartIn);
    }
  }

  function closeSizePanel(card) {
    var panel = card && card.querySelector('[data-product-card-size-panel]');
    var toggle = card && card.querySelector('[data-product-card-size-toggle]');
    var media = card && card.querySelector('.product-card-revamp__media');

    if (!panel) {
      return;
    }

    panel.hidden = true;

    if (media) {
      media.classList.remove('is-size-open');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-active');
    }

    if (openSizePanel === card) {
      openSizePanel = null;
    }
  }

  function closeAllSizePanels(exceptCard) {
    document.querySelectorAll(cardSelector).forEach(function (card) {
      if (card !== exceptCard) {
        closeSizePanel(card);
      }
    });
  }

  function toggleSizePanel(card) {
    var panel = card.querySelector('[data-product-card-size-panel]');
    var toggle = card.querySelector('[data-product-card-size-toggle]');
    var media = card.querySelector('.product-card-revamp__media');

    if (!panel || !toggle) {
      return;
    }

    var willOpen = panel.hidden;

    closeAllSizePanels(willOpen ? card : null);

    panel.hidden = !willOpen;

    if (media) {
      media.classList.toggle('is-size-open', willOpen);
    }

    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    toggle.classList.toggle('is-active', willOpen);
    openSizePanel = willOpen ? card : null;
  }

  function addToCart(variantId, button) {
    if (!variantId || !window.theme || !theme.routes || !theme.routes.cartAdd) {
      return Promise.reject(new Error('Cart route unavailable'));
    }

    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }

    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: 'id=' + encodeURIComponent(variantId) + '&quantity=1',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status === 422 || (data.status && data.status >= 400)) {
          throw data;
        }
        return data;
      });
    }).then(function (data) {
      if (data.status === 422 || (data.status && data.message)) {
        throw data;
      }

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        },
        bubbles: true
      }));

      return data;
    }).finally(function () {
      if (button) {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    });
  }

  function setNativeSwatchActive(card, swatch) {
    card.querySelectorAll('[data-product-card-native-swatch]').forEach(function (item) {
      var isActive = item === swatch;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function updateNativeSwatchCard(card, swatch) {
    var image = card.querySelector('.product-card-revamp__image-ratio img');
    var variantImage = swatch.getAttribute('data-variant-image');
    var variantLabel = swatch.getAttribute('data-variant-label') || '';
    var baseSubtitle = card.getAttribute('data-product-card-initial-subtitle') || '';

    if (image && variantImage) {
      image.src = variantImage;
      image.removeAttribute('srcset');
    }

    setNativeSwatchActive(card, swatch);
    renderTitle(card, {
      variantLabel: variantLabel,
      isSwatchSwitch: true
    });
    renderSubtitle(card, {
      subtitle: variantLabel || baseSubtitle,
      variantLabel: variantLabel
    });
  }

  function updateRevampActiveSwatch(card, productId) {
    card.querySelectorAll('[data-combined-product-swatch]').forEach(function (swatch) {
      var isActive = String(swatch.getAttribute('data-product-id')) === String(productId);

      swatch.classList.remove('combined-product-swatches__swatch--active', 'is-active');

      if (isActive) {
        swatch.classList.add('combined-product-swatches__swatch--active', 'is-active');
      }

      swatch.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function onSwatchChange(card, product) {
    updateRevampActiveSwatch(card, product.id);
    var swatchProduct = Object.assign({}, product, { isSwatchSwitch: true });
    renderTitle(card, swatchProduct);
    renderSubtitle(card, product);
    renderPrice(card, product);
    renderSizeGrid(card, product);
    updateSizeChart(card, product);
    closeSizePanel(card);

    if (window.ProductCardGallery && window.ProductCardGallery.reset) {
      window.ProductCardGallery.reset(card, product);
    }
  }

  function getCardProduct(card, preferredProductId) {
    var swatches = card.querySelector('[data-combined-product-swatches]');
    var products = parseProducts(swatches);
    var selectedId = preferredProductId || card.getAttribute('data-selected-product-id');
    var product = products.find(function (item) {
      return String(item.id) === String(selectedId);
    });

    return product || products[0] || null;
  }

  function initRevampCard(card) {
    var swatches = card.querySelector('[data-combined-product-swatches]');
    var product = null;

    if (swatches) {
      var firstSwatch = swatches.querySelector('[data-combined-product-swatch]');
      var firstProductId = firstSwatch ? firstSwatch.getAttribute('data-product-id') : null;
      var firstSwatchSubtitle = firstSwatch ? firstSwatch.getAttribute('data-product-subtitle') : '';

      if (firstProductId) {
        updateRevampActiveSwatch(card, firstProductId);
      }

      product = getCardProduct(card, firstProductId);

      if (product && firstSwatchSubtitle) {
        product = Object.assign({}, product, { subtitle: firstSwatchSubtitle });
      }
    } else {
      var firstNativeSwatch = card.querySelector('[data-product-card-native-swatch]');
      var initialSubtitle = card.getAttribute('data-product-card-initial-subtitle') || '';
      var nativeLabel = firstNativeSwatch ? firstNativeSwatch.getAttribute('data-variant-label') : '';

      product = {
        title: card.querySelector('[data-combined-product-card-title]') ? card.querySelector('[data-combined-product-card-title]').textContent : '',
        subtitle: initialSubtitle || nativeLabel,
        variantLabel: nativeLabel
      };
    }

    if (product) {
      if (!card.querySelector('.product-card-revamp__title--custom-meta')) {
        renderTitle(card, product);
      }
      renderSubtitle(card, product);
    } else {
      ensureSubtitleVisible(card);
    }
  }

  function initRevampCards(root) {
    var scope = root || document;

    scope.querySelectorAll(cardSelector).forEach(function (card) {
      initRevampCard(card);
    });
  }

  function bootRevampCards(root) {
    initRevampCards(root);
  }

  window.ProductCardRevamp = {
    onSwatchChange: onSwatchChange,
    updateActiveSwatch: updateRevampActiveSwatch,
    initCards: bootRevampCards
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootRevampCards(document);
    });
  } else {
    bootRevampCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootRevampCards(event.target);
  });

  document.addEventListener('recommendations:loaded', function (event) {
    bootRevampCards(event.detail && event.detail.section ? event.detail.section : document);
  });

  document.addEventListener('collection:reloaded', function () {
    bootRevampCards(document);
  });

  document.addEventListener('limoniapps:discountninja:collection:productsadded', function () {
    bootRevampCards(document);
  });

  document.addEventListener('click', function (event) {
    var card = event.target.closest(cardSelector);

    if (!card) {
      if (openSizePanel && !event.target.closest('[data-product-card-size-panel]') && !event.target.closest('[data-product-card-size-toggle]')) {
        closeSizePanel(openSizePanel);
      }
      return;
    }

    var sizeToggle = event.target.closest('[data-product-card-size-toggle]');
    if (sizeToggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleSizePanel(card);
      return;
    }

    var sizeClose = event.target.closest('[data-product-card-size-close]');
    if (sizeClose) {
      event.preventDefault();
      closeSizePanel(card);
      return;
    }

    var sizeOption = event.target.closest('[data-product-card-size-option]');
    if (sizeOption) {
      event.preventDefault();
      event.stopPropagation();

      var isUnavailable = sizeOption.classList.contains('is-unavailable') || sizeOption.getAttribute('aria-disabled') === 'true' || sizeOption.disabled;
      if (isUnavailable) {
        showToast('This size is currently out of stock.', 'warning');
        return;
      }

      var variantId = sizeOption.getAttribute('data-variant-id');
      card.dataset.selectedVariantId = variantId;

      addToCart(variantId, sizeOption).then(function () {
        closeSizePanel(card);
      }).catch(function (error) {
        var msg = 'This size is currently out of stock.';
        if (error) {
          if (error.description) {
            msg = error.description;
          } else if (error.message) {
            msg = error.message;
          }
        }
        showToast(msg, 'warning');
      });
      return;
    }

    var swatchesExpand = event.target.closest('[data-product-card-swatches-expand]');
    if (swatchesExpand) {
      event.preventDefault();
      event.stopPropagation();
      var swatchWrap = swatchesExpand.closest('[data-product-card-swatches]');
      if (swatchWrap) {
        swatchWrap.classList.add('is-expanded');
        swatchesExpand.hidden = true;
      }
      return;
    }

    var nativeSwatch = event.target.closest('[data-product-card-native-swatch]');
    if (nativeSwatch) {
      event.preventDefault();
      event.stopPropagation();
      updateNativeSwatchCard(card, nativeSwatch);
      return;
    }

    var sizeChartOpen = event.target.closest('[data-product-card-size-chart]');
    if (sizeChartOpen) {
      event.preventDefault();
      var modal = card.querySelector('[data-product-card-size-chart-modal]');
      if (modal) {
        modal.hidden = false;
      }
      return;
    }

    var sizeChartClose = event.target.closest('[data-product-card-size-chart-close]');
    if (sizeChartClose) {
      event.preventDefault();
      var closeModal = card.querySelector('[data-product-card-size-chart-modal]');
      if (closeModal) {
        closeModal.hidden = true;
      }
      return;
    }

    var sizeChartTab = event.target.closest('[data-size-chart-unit]');
    if (sizeChartTab) {
      event.preventDefault();
      var chartModal = card.querySelector('[data-product-card-size-chart-modal]');
      if (!chartModal) {
        return;
      }

      var unit = sizeChartTab.getAttribute('data-size-chart-unit');
      chartModal.querySelectorAll('[data-size-chart-unit]').forEach(function (tab) {
        tab.classList.toggle('is-active', tab === sizeChartTab);
      });
      chartModal.querySelectorAll('[data-size-chart-image]').forEach(function (image) {
        image.classList.toggle('is-active', image.getAttribute('data-size-chart-image') === unit);
      });
    }
  }, true);
})();
